module.exports = __webpack_public_path__ + "static/img/pic8.62026ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduce/pic8.png
// module id = DwTD
// module chunks = 1